const BRANCH_OFFICE = [
  {
    name: "柏市役場",
    lat: 35.86767391092762,
    lng: 139.97580801409637
  }
];

export { BRANCH_OFFICE };
